import React from 'react';

import { Divider, MenuItem } from '@mui/material';

import type { LensPublication } from '~/types/leLens';

export type LensPublicationMenuItemsProps = {
  publication: LensPublication;
  ownsDraft: boolean;
  draftShown: boolean;
  pending: boolean;
  onDiscard: () => void;
  onTakeOver: () => void;
  onShowDraft: (shown: boolean) => void;
  onClose: () => void;
};

export default function LensPublicationMenuItems({
  publication,
  ownsDraft,
  draftShown,
  pending,
  onDiscard,
  onTakeOver,
  onShowDraft,
  onClose,
}: LensPublicationMenuItemsProps) {
  const holder = publication.editorEmail && !ownsDraft;
  const changed = publication.publishedVersion === null || publication.hasUnpublishedChanges;
  const published = publication.publishedVersion !== null;
  const run = (action: () => void) => () => {
    onClose();
    action();
  };
  const items = [
    published && draftShown ? (
      <MenuItem key="published" disabled={pending} onClick={run(() => onShowDraft(false))}>
        See published
      </MenuItem>
    ) : null,
    published && !draftShown && changed ? (
      <MenuItem key="draft" disabled={pending} onClick={run(() => onShowDraft(true))}>
        See draft
      </MenuItem>
    ) : null,
    holder ? (
      <MenuItem key="takeover" disabled={pending} onClick={run(onTakeOver)}>
        Take over editing
      </MenuItem>
    ) : null,
    !holder && published && (changed || (ownsDraft && publication.draftVersion !== null)) ? (
      <MenuItem key="discard" disabled={pending} onClick={run(onDiscard)}>
        {changed ? 'Discard changes' : 'Discard draft'}
      </MenuItem>
    ) : null,
  ].filter(Boolean);

  return items.length ? [...items, <Divider key="publication-divider" sx={{ my: 0.5 }} />] : null;
}
